import React from 'react';

import { Heading, Slide, Section, preloader } from 'spectacle-ppa';

import imagePPALogo from '../../images/ppa_presents.svg';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './start.md';

import imgH2WLevelStart from '../../images/h2whoaLevelStart.png';

const levels = {
  '1': { img: imgH2WLevelStart },
  '2': { img: imgH2WLevelStart }
};

const md = new MarkdownScript(markdownFile);

export function preloadStart () {
  preloader([
    imagePPALogo,
    imgLevel1Start,
    imgLevel2Start
  ]);
}

function startSection ({ level, title, regionData }) {
  /* Level intro graphic */
  return (
    <Section id="start">

      <Slide
          id="ppa-presents"
          key="ppa-presents"
          bgColor="black"
          notes={md.getSubSectionAsHtml(`Level ${level} Start`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
            <img
                className="heading-image heading-image-before"
                src={imagePPALogo} />
          </div>
        </div>
      </Slide>

      {/* Sanksrit for Vanessa */}
      {/* lokah samastah sukhino bhavantu */}
      {/* may all beings everywhere be at peace */}

      <Slide
          id="level"
          key="level"
          bgColor="black"
          notes={md.getSubSectionAsHtml(`Level ${level} Icon`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="title-image"><img
              className="heading-image heading-image-before"
              src={levels[level].img} />
            <Heading size={1}>
              <strong>{title}</strong>
            </Heading>
            <Heading size={2}>
              <strong>Level {level}</strong>
            </Heading>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default startSection;



// WEBPACK FOOTER //
// ./programs/h2whoaHybrid/sections/01_start/startSection.jsx